'use client'

import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Link from 'next/link';

export default function Blog() {
  return (
    <main className="min-h-screen flex flex-col">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-teal-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-900 mb-6">Blog</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Dicas, informações e novidades sobre fisioterapia, saúde e bem-estar.
            </p>
          </div>
        </div>
      </section>
      
      {/* Blog Posts Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Blog Post 1 */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-48 bg-gray-200"></div>
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-2">
                  <span>12 de Maio, 2025</span>
                  <span className="mx-2">•</span>
                  <span>Reabilitação Neurológica</span>
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  <Link href="/blog/exercicios-mobilidade-avc" className="hover:text-teal-600">
                    Exercícios para melhorar a mobilidade após AVC
                  </Link>
                </h2>
                <p className="text-gray-600 mb-4">
                  Conheça exercícios simples que podem ser realizados em casa para complementar o tratamento de fisioterapia após um AVC.
                </p>
                <Link
                  href="/blog/exercicios-mobilidade-avc"
                  className="text-teal-600 hover:text-teal-800 font-medium"
                >
                  Ler mais →
                </Link>
              </div>
            </div>

            {/* Blog Post 2 */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-48 bg-gray-200"></div>
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-2">
                  <span>5 de Maio, 2025</span>
                  <span className="mx-2">•</span>
                  <span>Doença de Parkinson</span>
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  <Link href="/blog/fisioterapia-parkinson" className="hover:text-teal-600">
                    A importância da fisioterapia na doença de Parkinson
                  </Link>
                </h2>
                <p className="text-gray-600 mb-4">
                  Descubra como a fisioterapia pode ajudar a gerenciar os sintomas e melhorar a qualidade de vida de pacientes com Parkinson.
                </p>
                <Link
                  href="/blog/fisioterapia-parkinson"
                  className="text-teal-600 hover:text-teal-800 font-medium"
                >
                  Ler mais →
                </Link>
              </div>
            </div>

            {/* Blog Post 3 */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-48 bg-gray-200"></div>
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-2">
                  <span>28 de Abril, 2025</span>
                  <span className="mx-2">•</span>
                  <span>Cuidadores</span>
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  <Link href="/blog/dicas-cuidadores" className="hover:text-teal-600">
                    Dicas para cuidadores de pacientes neurológicos
                  </Link>
                </h2>
                <p className="text-gray-600 mb-4">
                  Orientações práticas para familiares e cuidadores que auxiliam pacientes com condições neurológicas em casa.
                </p>
                <Link
                  href="/blog/dicas-cuidadores"
                  className="text-teal-600 hover:text-teal-800 font-medium"
                >
                  Ler mais →
                </Link>
              </div>
            </div>

            {/* Blog Post 4 */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-48 bg-gray-200"></div>
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-2">
                  <span>20 de Abril, 2025</span>
                  <span className="mx-2">•</span>
                  <span>Fisioterapia Geriátrica</span>
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  <Link href="/blog/prevencao-quedas-idosos" className="hover:text-teal-600">
                    Prevenção de quedas em idosos: exercícios e adaptações domiciliares
                  </Link>
                </h2>
                <p className="text-gray-600 mb-4">
                  Aprenda como prevenir quedas em idosos através de exercícios específicos e adaptações simples no ambiente doméstico.
                </p>
                <Link
                  href="/blog/prevencao-quedas-idosos"
                  className="text-teal-600 hover:text-teal-800 font-medium"
                >
                  Ler mais →
                </Link>
              </div>
            </div>

            {/* Blog Post 5 */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-48 bg-gray-200"></div>
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-2">
                  <span>15 de Abril, 2025</span>
                  <span className="mx-2">•</span>
                  <span>Fisioterapia Respiratória</span>
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  <Link href="/blog/recuperacao-pos-covid" className="hover:text-teal-600">
                    Fisioterapia respiratória na recuperação pós-COVID
                  </Link>
                </h2>
                <p className="text-gray-600 mb-4">
                  Como a fisioterapia respiratória pode ajudar na recuperação de pacientes que tiveram COVID-19 e apresentam sequelas respiratórias.
                </p>
                <Link
                  href="/blog/recuperacao-pos-covid"
                  className="text-teal-600 hover:text-teal-800 font-medium"
                >
                  Ler mais →
                </Link>
              </div>
            </div>

            {/* Blog Post 6 */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="h-48 bg-gray-200"></div>
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-2">
                  <span>10 de Abril, 2025</span>
                  <span className="mx-2">•</span>
                  <span>Fisioterapia Desportiva</span>
                </div>
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  <Link href="/blog/lesoes-comuns-corredores" className="hover:text-teal-600">
                    Lesões comuns em corredores: prevenção e tratamento
                  </Link>
                </h2>
                <p className="text-gray-600 mb-4">
                  Conheça as lesões mais comuns em corredores e aprenda como preveni-las e tratá-las adequadamente.
                </p>
                <Link
                  href="/blog/lesoes-comuns-corredores"
                  className="text-teal-600 hover:text-teal-800 font-medium"
                >
                  Ler mais →
                </Link>
              </div>
            </div>
          </div>

          {/* Pagination */}
          <div className="mt-12 flex justify-center">
            <nav className="inline-flex rounded-md shadow">
              <a href="#" className="px-4 py-2 rounded-l-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50">
                Anterior
              </a>
              <a href="#" className="px-4 py-2 border-t border-b border-gray-300 bg-teal-600 text-white">
                1
              </a>
              <a href="#" className="px-4 py-2 border-t border-b border-gray-300 bg-white text-gray-700 hover:bg-gray-50">
                2
              </a>
              <a href="#" className="px-4 py-2 border-t border-b border-gray-300 bg-white text-gray-700 hover:bg-gray-50">
                3
              </a>
              <a href="#" className="px-4 py-2 rounded-r-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50">
                Próxima
              </a>
            </nav>
          </div>
        </div>
      </section>
      
      {/* Categories Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Categorias</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Explore nossos artigos por categoria.
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Link href="/blog/categoria/reabilitacao-neurologica" className="bg-white p-4 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-900">Reabilitação Neurológica</h3>
              <p className="text-gray-500 text-sm">12 artigos</p>
            </Link>
            
            <Link href="/blog/categoria/fisioterapia-desportiva" className="bg-white p-4 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-900">Fisioterapia Desportiva</h3>
              <p className="text-gray-500 text-sm">8 artigos</p>
            </Link>
            
            <Link href="/blog/categoria/fisioterapia-geriatrica" className="bg-white p-4 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-900">Fisioterapia Geriátrica</h3>
              <p className="text-gray-500 text-sm">6 artigos</p>
            </Link>
            
            <Link href="/blog/categoria/fisioterapia-respiratoria" className="bg-white p-4 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-900">Fisioterapia Respiratória</h3>
              <p className="text-gray-500 text-sm">5 artigos</p>
            </Link>
            
            <Link href="/blog/categoria/dicas-para-cuidadores" className="bg-white p-4 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-900">Dicas para Cuidadores</h3>
              <p className="text-gray-500 text-sm">7 artigos</p>
            </Link>
            
            <Link href="/blog/categoria/exercicios-em-casa" className="bg-white p-4 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-900">Exercícios em Casa</h3>
              <p className="text-gray-500 text-sm">9 artigos</p>
            </Link>
            
            <Link href="/blog/categoria/saude-e-bem-estar" className="bg-white p-4 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-900">Saúde e Bem-estar</h3>
              <p className="text-gray-500 text-sm">11 artigos</p>
            </Link>
            
            <Link href="/blog/categoria/noticias-e-pesquisas" className="bg-white p-4 rounded-lg shadow-md text-center hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-lg font-semibold text-gray-900">Notícias e Pesquisas</h3>
              <p className="text-gray-500 text-sm">4 artigos</p>
            </Link>
          </div>
        </div>
      </section>
      
      {/* Newsletter Section */}
      <section className="py-16 bg-teal-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6">Inscreva-se em Nossa Newsletter</h2>
            <p className="text-xl mb-8">
              Receba nossos artigos mais recentes, dicas de saúde e novidades diretamente em seu e-mail.
            </p>
            <form className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                placeholder="Seu e-mail"
                className="flex-1 px-4 py-3 rounded-md text-gray-900"
              />
              <button
                type="submit"
                className="px-6 py-3 bg-teal-800 hover:bg-teal-900 text-white font-medium rounded-md transition-colors duration-300"
              >
                Inscrever-se
              </button>
            </form>
            <p className="mt-4 text-sm text-teal-100">
              Ao se inscrever, você concorda com nossa Política de Privacidade. Você pode cancelar sua inscrição a qualquer momento.
            </p>
          </div>
        </div>
      </section>
      
      <Footer />
    </main>
  );
}
